export * from "@/marketing/catalogBase";

import {
  PROTECTED_PAGES as BASE_PROTECTED_PAGES,
  PUBLIC_PAGES as BASE_PUBLIC_PAGES,
  pageMeta as basePageMeta,
} from "@/marketing/catalogBase";
import type { PageMeta } from "@/marketing/catalogBase";
import { helpPageMeta } from "@/marketing/documentation/catalog";

export const PUBLIC_PAGES = [...BASE_PUBLIC_PAGES, ...helpPageMeta];
export const PROTECTED_PAGES = BASE_PROTECTED_PAGES;

export function pageMeta(pathname: string): PageMeta {
  const clean = pathname.replace(/\/+$/, "") || "/";
  return (helpPageMeta.find((page) => page.path === clean) as PageMeta | undefined)
    ?? basePageMeta(clean);
}

export const indexablePages = PUBLIC_PAGES.filter(
  (page) => page.robots === "index,follow",
);
